//own imports
import './App.css';
import 'bulma/css/bulma.css';
import {
  NetworkStatus
} from './components/common/networkState/network';

//React imports
import React, {  } from 'react';
import {
  ToastContainer
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Firebase imports
import {
  FirebaseAppProvider
} from 'reactfire';

import Pages from './components/pages';
import { Navbar } from './components/common';

// DARKMODE //
import {
  ThemeProvider
} from "styled-components";
import {
  GlobalStyles
} from "./components/globalStyles";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: "AIzaSyBqU42lAjLn0NUdTEwAexRmyt3Bs333g0I",
  authDomain: "expensor-78ad1.firebaseapp.com",
  projectId: "expensor-78ad1",
  storageBucket: "expensor-78ad1.appspot.com",
  messagingSenderId: "685316790253",
  appId: "1:685316790253:web:79dcd75c79f9197fe439e4",
  measurementId: "G-LC26DDDV3H"
};

export const lightThemes = {
  body: '#FFF',
  text: '#363537',
  toggleBorder: '#FFF',
  background: '#363537',
  theme: 'light',
  boxColor: '#E9F3F3',
  kpiColor: '#2f4f4f',
  item: '#18a8c5'
}
export const darkThemes = {
  body: '#363537',
  text: '#FAFAFA',
  toggleBorder: '#6B8096',
  background: '#999',
  theme: 'dark',
  boxColor: '#2d2c2d',
  kpiColor: '#027B93',
  item: '#054E5D'
}

const currentTheme = localStorage.getItem('Theme');
let themes;
if (currentTheme === null) {
  localStorage.setItem('Theme', 'light');
  themes = lightThemes
}
else if (currentTheme === 'dark') {
  themes = darkThemes;
}
else if (currentTheme === 'light') {
  themes = lightThemes;
}

export const ThemeContext = React.createContext({
  theme: themes,
  toggleTheme: () => {},
});

class App extends React.Component {

  constructor(props) {
      super(props);
      
      this.toggleTheme = () => {
        this.setState(state => ({
          theme: state.theme === darkThemes ?
            lightThemes :
            darkThemes,
        }));
      };
      this.state = {
        theme: themes,
        toggleTheme: this.toggleTheme,
      };
    }

  render() {
    return (
      <ThemeProvider theme={this.state.theme.theme === 'light' ? lightThemes: darkThemes}>
        <GlobalStyles/>
        <div className="App" id="App">
          <ToastContainer autoClose={3000} hideProgressBar/>
          <NetworkStatus/>
          <FirebaseAppProvider firebaseConfig={firebaseConfig}> 
            <Navbar/>
            <ThemeContext.Provider value={this.state}>
              <Pages/>
            </ThemeContext.Provider>
          </FirebaseAppProvider>
        </div>
      </ThemeProvider>
    );
  };
}

export default App;